module.exports = __webpack_public_path__ + "img/board-2.3fb54b86.png";